<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'EntitiesTagsExpertsTestProfilsExperts'
});
</script>
<template>
  <ka-container
    code="tags-experts"
    :options="options">
    <ka-text code="text">
      <span v-html="tagsExpertsItem.Nom" />
    </ka-text>
  </ka-container>
</template>

<script setup lang="ts">
import { syncEntityStore } from 'kapix-components-vue3'
import type { IPropOptions } from 'kapix-components-vue3'
import { entitiesTagsExpertsTestProfilsExpertsComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--test-profils-experts-e19')
const component = entitiesTagsExpertsTestProfilsExpertsComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  tagsExperts?: PartialEntity<Kapix.Entity.ITagsExperts>
  options?: IPropOptions
}>(), {
  tagsExperts: undefined,
  options: undefined
})

const tagsExpertsItem = syncEntityStore<Partial<Kapix.Entity.ITagsExperts>>(componentInstance, {
  props,
  propName: 'tagsExperts',
  defaultValue: {}
})
</script>
